import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuardService, AdminGuardService, DataEngineerGuardService, ServiceCompanyGuardService } from '../shared/guards';
import { RenameChannelComponent } from '../shared/components/rename-channel/rename-channel.component';

const routes: Routes = [{
  path: '',
  component: PagesComponent,
  canActivate: [AuthGuardService],
  children: [
    {
      path: 'dashboard',
      component: DashboardComponent
    },
    {
      path: 'user',
      loadChildren: 'app/pages/user/user.module#UserModule'
    },
    {
      path: 'pads',
      loadChildren: 'app/pages/pad/pad.module#PadModule',
      canActivate: [DataEngineerGuardService]
    },
    {
      path: 'wells',
      loadChildren: 'app/pages/wells/wells.module#WellsModule',
      canActivate: [DataEngineerGuardService]
    },
    {
      path: 'inventory',
      loadChildren: 'app/pages/inventory/inventory.module#InventoryModule',
      canActivate: [ServiceCompanyGuardService]
    },
    {
      path: 'treatments',
      loadChildren: 'app/pages/treatments/treatments.module#TreatmentsModule',
    },
    {
      path: 'manage',
      loadChildren: 'app/pages/manage/manage.module#ManageModule',
      canActivate: [AdminGuardService]
    },
    {
      path: 'renameChannel',
      component: RenameChannelComponent,
      canActivate: [DataEngineerGuardService]
    },
    {
      path: 'channelMapping',
      loadChildren: 'app/pages/channel-mapping/channel-mapping.module#ChannelMappingModule',
      canActivate: [DataEngineerGuardService]
    },
    {
      path: 'equipMonitoring',
      loadChildren: 'app/pages/equip-monitoring/equip-monitoring.module#EquipMonitoringModule',
      canActivate: [ServiceCompanyGuardService]
    },
    {
      path: '',
      redirectTo: 'dashboard',
      pathMatch: 'full',
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}
